import {Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ICsItemElementClickArg} from "@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item.interface";
import {ICsDdItem} from "@app/shared/cs-components/cs-drop-down/cs-drop-down.interface";

@Component({
    selector: 'app-cs-drop-down-item-templates',
    templateUrl: './cs-drop-down-item-templates.component.html',
    styleUrls: ['cs-drop-down-item-templates.component.scss']
})
export class CsDropDownItemTemplatesComponent implements OnInit {

    @Output() onItemClick = new EventEmitter<ICsDdItem>();
    @Output() onItemElementClick = new EventEmitter<ICsItemElementClickArg>();

    @ViewChild('basicTemplate') basicTemplate: TemplateRef<any>;

    constructor() { }

    ngOnInit() {
    }

    itemClick(item: ICsDdItem) {
        this.onItemClick.emit(item);
    }

    itemElementClick(data: ICsItemElementClickArg) {
        // data.item.indicatorIcon = data.item.templateData.iconsList.find(icon => icon.isItemIndicator) || null;
        this.onItemElementClick.emit(data);
    }

}
